import { Redirect } from "@reach/router";
import React from "react";

function Redir() {
  return <Redirect to="/" />;
}

export default Redir;
